import { createDocument, getAllData } from 'apis/customApiHandler';
import React, { Fragment, useCallback, useState } from 'react'
import { BiCloudDownload } from "react-icons/bi";
import { useQuery } from 'react-query';
import { TD, TH } from "styled/table";
import ReactSelect from 'react-select';
import { Button } from 'styled'
import exportExcel from 'utils/exportExcel';
import Spinner from 'components/Spinner';
import Modal from 'components/Modal';

const GrnPendingReport = () => {
    const [selectedFleets, setSelectedFleets] = useState([]);
    const [selectedHubs, setSelectedHubs] = useState([]);
    const [data, setData] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [fleetMap, setFleetMap] = useState({});
    const [downloading, setDownloading] = useState(false)
    const [reportData, setReportData] = useState({})

    const getData = async () => {
        setIsLoading(true)
        try {
            const dt = await createDocument("/report/grnPendingReports", {
                ...(selectedFleets?.includes("all")
                    ? {
                        fleets: getFleetOptions().filter(item => item.value !== "all" && item.value !== "clear")
                            .map((item) => item.value)
                            .join(","),
                    }
                    : selectedFleets.length && {
                        fleets: selectedFleets.map((fleet) => fleet).join(","),
                    }),
                ...(selectedHubs?.includes("all")
                    ? {
                        hubs: getHubOptions().filter(item => item.value !== "all" && item.value !== "clear")
                            .map((item) => item.value)
                            .join(","),
                    }
                    : selectedHubs.length && {
                        hubs: selectedHubs.map((hub) => hub).join(","),
                    })
            })
            // console.log("dt", dt)
            setData(dt);
        } catch (err) {

        } finally {
            setIsLoading(false)
        }

    }

    const getDownloadData = async () => {
        setDownloading(true)
        try {
            const dt = await createDocument("/report/grnPendingReports", {
                ...(selectedFleets?.includes("all")
                    ? {
                        fleets: getFleetOptions().filter(item => item.value !== "all" && item.value !== "clear")
                            .map((item) => item.value)
                            .join(","),
                    }
                    : selectedFleets.length && {
                        fleets: selectedFleets.map((fleet) => fleet).join(","),
                    }),
                ...(selectedHubs?.includes("all")
                    ? {
                        hubs: getHubOptions().filter(item => item.value !== "all" && item.value !== "clear")
                            .map((item) => item.value)
                            .join(","),
                    }
                    : selectedHubs.length && {
                        hubs: selectedHubs.map((hub) => hub).join(","),
                    }),
            });

            if (dt.data) {
                console.log("dt?.data" , dt?.data)
                let exportData = dt?.data?.map((x, idx) => ({
                    "Fleet Name": `${x?._id?.fleet} (${x?.fleetCity ?? "---"})`,
                    "Hub Name": x?._id?.hub,
                    "0 - 3": x?.zeroTo3Days.length ?? 0,
                    "4 - 6": x?.fourTo6Days.length ?? 0,
                    "7 - 9": x?.sevenTo9Days.length ?? 0,
                    "10 - 12": x?.tenTo12Days.length ?? 0,
                    "13 - 15": x?.thirteenTo15Days.length ?? 0,
                    "16 - 19": x?.sixteenTo19Days.length ?? 0,
                    "20 - 28": x?.twentyTo28Days.length ?? 0,
                    "29 - 30": x?.twentyNineTo30Days.length ?? 0,
                    ">30": x?.moreThan30Days.length ?? 0,
                    "TOTAL" : x?.totalData.length ?? 0,
                   
                }))

                exportData.push({
                    "0 - 3": dt?.totalRow?.zeroTo3Days ?? 0,
                    "4 - 6": dt?.totalRow?.fourTo6Days ?? 0,
                    "7 - 9": dt?.totalRow?.sevenTo9Days ?? 0,
                    "10 - 12": dt?.totalRow?.tenTo12Days ?? 0,
                    "13 - 15": dt?.totalRow?.thirteenTo15Days ?? 0,
                    "16 - 19": dt?.totalRow?.sixteenTo19Days ?? 0,
                    "20 - 28": dt?.totalRow?.twentyTo28Days ?? 0,
                    "29 - 30": dt?.totalRow?.twentyNineTo30Days ?? 0,
                    ">30": dt?.totalRow?.moreThan30Days ?? 0,
                    "TOTAL" : dt?.totalRow.total ?? 0
                    
                })

                exportExcel(exportData, "Grn Pending Report", true)
            }
        } catch (err) {

        }
        finally { setDownloading(false) }

    }

    const { data: allFleets } = useQuery([`/customer-fleet`], () =>
        getAllData("/customer-fleet", {
            limit: 3000,
        })
    );
    const { data: allHubs } = useQuery([`/customer-hub`], () =>
        getAllData("/customer-hub", {
            limit: 3000,
        })
    );

    const getFleetOptions = useCallback(() => {
        if (allFleets && allFleets.data && allFleets.data.length) {
            return [
                {
                    label: "All",
                    value: "all",
                },
                {
                    label: "Clear",
                    value: "clear",
                },
                ...allFleets?.data?.map((fleet) => {
                    return {
                        value: fleet._id,
                        label: fleet.fleetName,
                    };
                }),
            ];
        }
    }, [allFleets]);

    const getHubOptions = useCallback(() => {
        if (allHubs && allHubs.data && allHubs.data.length) {
            return [
                ...selectedFleets?.length ? [{
                    label: "All",
                    value: "all",
                  }]: [],
                  ...selectedFleets?.length ? [{
                    label: "Clear",
                    value: "clear",
                  }]: [],
                ...(selectedFleets?.includes("all") ?
                    allHubs?.data?.length &&
                    allHubs?.data
                        ?.map((hub) => {
                            return {
                                value: hub.hubCode,
                                label: hub.hubName,
                            };
                        }) :
                    allHubs?.data?.length &&
                    allHubs?.data
                        ?.filter((hub) => {
                            const selectedFleetsVal = allFleets?.data?.filter((fleet) =>
                                selectedFleets?.includes(fleet._id)
                            );

                            return selectedFleetsVal?.some(
                                (fleet) => fleet.fleetCode === hub.fleetCode
                            );
                        })
                        ?.map((hub) => {
                            return {
                                value: hub.hubCode,
                                label: hub.hubName,
                            };
                        })),
            ];
        }
    }, [allFleets, allHubs, selectedFleets]);

    return (
        <div>
            <div className="w-full px-8 flex justify-center items-center mt-4 gap-4">
                <label className="w-full ">
                    Select Fleets
                    <ReactSelect

                        styles={{
                            control: (base, state) => ({
                                ...base,
                                borderColor: "transparent",
                                minWidth: "100%",
                                "&:hover": {
                                    borderColor: "rgb(34 197 94)",
                                },
                            }),
                        }}
                        className="shadow-md rounded-md py-1 mb-2"
                        options={getFleetOptions()}
                        value={
                            selectedFleets &&
                            selectedFleets?.map((fleet) => {
                                return {
                                    value: fleet,
                                    label: getFleetOptions()?.find((item) => item?.value === fleet)
                                        ?.label,
                                };
                            })
                        }
                        onChange={(value) => {
                            let allValues = value?.map((item) => item.value);
                            if (allValues?.includes("clear")) {
                                console.log(allValues)
                                setSelectedFleets([]);
                                setSelectedHubs([]);
                                return;
                            }
                            if (!selectedFleets?.includes("all") && allValues.includes("all")) {
                                setSelectedFleets(["all"]);
                                return;
                            }

                            if (selectedFleets.includes("all")) {
                                console.log("first");
                                console.log(getFleetOptions())
                                value = value.filter(item => item.value !== "all")
                            }

                            // console.log(allValues)
                            // console.log({selectedFleets, value})
                            let selectedFleetsVal = allFleets?.data?.filter((fleet) =>
                                value?.map((item) => item.value)?.includes(fleet._id)
                            );

                            let selectedHubsVal = allHubs?.data?.filter((hub) =>
                                selectedHubs?.map((item) => item)?.includes(hub._id)
                            );

                            setSelectedHubs(
                                selectedHubsVal
                                    ?.filter((hub) =>
                                        selectedFleetsVal?.find(
                                            (fleet) => fleet.fleetCode === hub.fleetCode
                                        )
                                    )
                                    .map((hub) => hub._id)
                            );

                            console.log({ allHubs, selectedHubs })

                            setSelectedFleets(value.map((fleet) => fleet.value));
                        }
                        }
                        name="fleets"
                        isMulti={true}
                    // isMulti={selectedFleets?.includes("all") ? false : true}
                    // isDisabled={selectedFleets?.includes("all") ? true : false}
                    />
                </label>

                <label className="w-full ">
                    Select Hubs
                    <ReactSelect
                        styles={{
                            control: (base, state) => ({
                                ...base,
                                borderColor: "transparent",
                                minWidth: "100%",
                                "&:hover": {
                                    borderColor: "rgb(34 197 94)",
                                },
                            }),
                        }}
                        className="shadow-md rounded-md py-1 mb-2"
                        options={getHubOptions()}
                        value={
                            selectedHubs &&
                            selectedHubs?.map((hub) => {
                                console.log({ hub })
                                return {
                                    value: hub,
                                    label: getHubOptions()?.find((item) => item.value === hub)
                                        ?.label,
                                };
                            })
                        }
                        onChange={(value) => {
                            const allValues = value?.map((item) => item.value);
                            console.log({ allValues })
                            if (allValues.includes("clear")) {
                                setSelectedHubs([])
                                return;
                            }
                            if (!selectedHubs?.includes("all") && allValues.includes("all")) {
                                let selectedFleetCodes = allFleets?.data?.filter((fleet) =>
                                    selectedFleets?.includes(fleet._id)
                                )?.map(fleet => fleet.fleetCode);

                                const selectedHubsData = allHubs?.data?.filter(hub => selectedFleetCodes?.includes(hub.fleetCode))

                                const mp = fleetMap;
                                selectedHubsData.map(hub => {
                                    if (selectedFleetCodes?.includes(hub.fleetCode)) {
                                        if (mp[hub.fleetCode] === undefined) mp[hub.fleetCode] = [];
                                        mp[hub.fleetCode] = [...mp[hub.fleetCode], hub._id]
                                    }
                                })

                                setFleetMap(mp);
                                // console.log({value})
                                // console.log({selectedFleetCodes, selectedHubsData, fleetMap})

                                // setSelectedHubs((pre) =>
                                //   allHubs?.data
                                //     ?.filter((hub) => {
                                //       const selectedFleetsVal = allFleets?.data?.filter(
                                //         (fleet) => selectedFleets?.includes(fleet._id)
                                //       );
                                //       return selectedFleetsVal?.some(
                                //         (fleet) => fleet.fleetCode === hub.fleetCode
                                //       );
                                //     })
                                //     ?.map((hub) => hub._id)
                                // );
                                setSelectedHubs(["all"])
                            }
                            else {
                                console.log({ value })
                                value = value.filter(value => value.value !== "all")
                                console.log({ value })
                                let selectedFleetCodes = allFleets?.data?.filter((fleet) =>
                                    selectedFleets?.includes(fleet._id)
                                )?.map(fleet => fleet.fleetCode);
                                console.log({ allValues })

                                const selectedHubsData = allHubs?.data?.filter(hub => allValues?.includes(hub._id))
                                // setFleetMap({});
                                const mp = {};
                                selectedHubsData.map(hub => {
                                    mp[hub.fleetCode] = [];
                                })

                                selectedHubsData.map(hub => {
                                    if (selectedFleetCodes?.includes(hub.fleetCode)) {
                                        if (mp[hub.fleetCode] === undefined) mp[hub.fleetCode] = [];
                                        mp[hub.fleetCode] = [...mp[hub.fleetCode], hub._id]
                                    }
                                })

                                setFleetMap(mp);

                                // console.log({value})
                                // console.log({selectedFleetCodes, selectedHubsData, fleetMap})

                                setSelectedHubs(value.map((hub) => hub.value));
                            }
                        }}
                        name="hubs"
                        isMulti={true}
                    />
                </label>

                <Button className='mt-5' type="button" disabled={(!selectedHubs.length)} bgPrimary onClick={() => getData()} >
                    Search
                </Button>
                {downloading ? 'Downloading...' : selectedHubs.length !== 0 && <BiCloudDownload
                    className="w-20 mt-5 h-20 text-green-500 hover:scale-105 cursor-pointer text-center"
                    onClick={() => {
                        getDownloadData()
                    }}
                />}
            </div>
            {isLoading ? (
                <Spinner />
            ) : (
                <div className="flex flex-col m-2 lg:m-10">
                    <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                        <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                            <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                                <table className="min-w-full divide-y divide-gray-200">
                                    <thead className="bg-gray-50">
                                        <tr>
                                            <TH scope="col">S.N.</TH>
                                            <TH scope="col">Fleet Name</TH>
                                            <TH scope="col">Hub Name </TH>
                                            <TH scope="col">0 - 3 </TH>
                                            <TH scope="col">4 - 6 </TH>
                                            <TH scope="col">7 - 9 </TH>
                                            <TH scope="col">10 - 12 </TH>
                                            <TH scope="col">13 - 15 </TH>
                                            <TH scope="col">16 - 19 </TH>
                                            <TH scope="col">20 - 28 </TH>
                                            <TH scope="col">29 - 30 </TH>
                                            <TH scope="col">{">30"}</TH>
                                            <TH scope="col">Grand Total</TH>
                                        </tr>
                                    </thead>
                                    <tbody className="bg-white divide-y divide-gray-200">
                                        {data && data.data &&
                                            data.data?.map((entry, idx) => {
                                                console.log("entry inside row" , entry)

                                                return <ViewList fleetName={entry?._id?.fleet} hubName = {entry?._id?.hub} data={entry} idx={idx} 
                                                fleetCity={entry?.fleetCity}
                                                />
                                            })}
                                    </tbody>
                                    {data?.totalRow?.total ? <tfoot>
                                        <tr className="text-gray-600 font-semibold bg-green-100">
                                        <TD></TD>
                                            <TD colSpan={2} className='text-left'>
                                                TOTAL
                                            </TD>
                                            
                                            <TD className="text-center">
                                                {data?.totalRow?.zeroTo3Days}
                                            </TD>
                                            <TD className="text-center">
                                                {data?.totalRow?.fourTo6Days}
                                            </TD>
                                            <TD className="text-center">
                                                {data?.totalRow?.sevenTo9Days}
                                            </TD>
                                            <TD className="text-center">
                                                {data?.totalRow?.tenTo12Days}
                                            </TD>
                                            <TD className="text-center">
                                                {data?.totalRow?.thirteenTo15Days}
                                            </TD>
                                            <TD className="text-center">
                                                {data?.totalRow?.sixteenTo19Days}
                                            </TD>
                                            <TD className="text-center">
                                                {data?.totalRow?.twentyTo28Days}
                                            </TD>
                                            <TD className="text-center">
                                                {data?.totalRow?.twentyNineTo30Days}
                                            </TD>
                                            <TD className="text-center">
                                                {data?.totalRow?.moreThan30Days}
                                            </TD>
                                            <TD className="text-center">
                                                {data?.totalRow?.total}
                                            </TD>
                                        </tr>
                                    </tfoot> : <></>}
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>

      
    );
}

export default GrnPendingReport


const ViewList = ({ fleetName,hubName, data, idx,fleetCity }) => {
    console.log('fleetCity--',fleetCity)
    const [showModal, setShowModal] = useState(false);
    const [modalData, setModalData] = useState([]);
    const [fleet, setFleet] = useState("")
    // console.log({fleetName})
    const modalHandler = useCallback(
        (data) => {
            if (data) {
                setModalData(data);
                setShowModal(true);
            } else {
                setShowModal(false);
                setModalData([]);
            }
        },
        [showModal, modalData]
    );

    const downloadDiv = (fleetName, data, title) => {
        return data && <div className="flex gap-2 items-center justify-center">
            <span
                className="hover:text-green-500 cursor-pointer"
                onClick={() => { modalHandler({ data, title: fleetName + " (" + (fleetCity ?? "-") + ") GRN Pending Reports " + title }); setFleet(fleetName) }}
            >
                {data?.length ?? 0}
            </span>
        </div>
    }

    // console.log(data)

    return (
        <Fragment>
            {showModal && (
                <Modal
                    handleClick={() => setShowModal(false)}
                    title={"GRN Pending Reports Details"}
                    className="max-w-2xl"
                >
                    {/* <h1>This is the modal</h1> */}
                    <h1 className="w-full flex justify-end text-end px-2 my-1">
                        <Button
                            onClick={() => {
                                exportExcel(
                                    modalData?.data?.map((item , index) => ({
                                      'S.NO' : index + 1,
                                      'DATE' : item.grnDate,
                                      'CHALLAN NUMBER' : item.Challan_No,
                                      'TYRE SIZE' : item.tyreSize,
                                      'STENCIL NUMBER' : item.stencilNumber
                                    }
                                    )),
                                    modalData.title.split(" ").join("_") + "_Data"
                                );
                            }}
                            className=" text-blue-500 hover:scale-105 cursor-pointer text-right"
                        >
                            Download
                        </Button>
                    </h1>
                    <table className="min-w-full divide-y divide-gray-200">
                        <thead className="bg-gray-50">
                            <tr>
                                <TH scope="col">S.N.</TH>
                                <TH scope="col">Date</TH>
                                <TH scope="col">Challan Number</TH>
                                <TH scope="col">Tyre Size</TH>
                                <TH scope="col">Stencil Number</TH>
                            </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                            {modalData &&
                                modalData?.data?.length > 0 &&
                                modalData?.data?.map((vehicle, index) => (
                                    <tr>
                                        <TD>{index + 1}</TD>
                                        <TD>{vehicle.grnDate}</TD>
                                        <TD>{vehicle.Challan_No}</TD>
                                        <TD>{vehicle.tyreSize}</TD>
                                        <TD>{vehicle.stencilNumber}</TD>
                                    </tr>
                                ))}
                        </tbody>
                    </table>
                </Modal>
            )}
            <tr className={`${idx % 2 !== 0 && "bg-gray-100"}`}>
                <TD>{idx + 1}</TD>
                <TD>{fleetName} ({fleetCity})</TD>
                <TD>{hubName}</TD>
                <TD>
                    {downloadDiv(fleetName, data?.zeroTo3Days, '0 - 3 Days')}
                </TD>
                <TD>
                    {downloadDiv(fleetName, data?.fourTo6Days, "4 - 6 Days")}
                </TD>
                <TD>
                    {downloadDiv(fleetName, data?.sevenTo9Days, "7 - 9 Days")}
                </TD>
                <TD>
                    {downloadDiv(fleetName, data?.tenTo12Days, "10 - 12 Days")}
                </TD>
                <TD>
                    {downloadDiv(fleetName, data?.thirteenTo15Days, '13 - 15 Days')}
                </TD>
                <TD>
                    {downloadDiv(fleetName, data?.sixteenTo19Days, '16 - 19 Days')}
                </TD>
                <TD>
                    {downloadDiv(fleetName, data?.twentyTo28Days, '20 - 28 Days')}
                </TD>
                <TD>
                    {downloadDiv(fleetName, data?.twentyNineTo30Days, '29 - 30 Days')}
                </TD>
                <TD>
                    {downloadDiv(fleetName, data?.moreThan30Days, '>30 Days')}
                </TD>
                <TD>
                    {downloadDiv(fleetName, data?.totalData, 'Grand Total')}
                </TD>

            </tr>
        </Fragment>
    );
};
